// Import necessary styles and libraries
import { createApp } from 'vue';
import ImportHikeDialog from "./ImportHikeDialog.vue";

// Check if the specific element exists in the DOM
if (document.querySelector('#vue-import-hike-dialog')) {
  // Create a new Vue instance and mount it to the element
  const app = createApp(ImportHikeDialog);
  app.mount('#vue-import-hike-dialog');
}
